const SIGNATURE_ELECTRONIQUE = {
  title: 'Modifier token',
  information: {
    title: 'Informations générale',
    token: 'Token',
    referenceExterne: 'Reference externe',
  },
  initialisation: {
    title: 'Initialisation',
    callBack: 'Initialiser le callBack',
    successCallBack: 'L\'initialisation du callBack a été faite avec succès.',
  },
  successEdit: 'Le token a été modifié avec succès.',
  error: {
    tokenEmpty: 'Le token est obligatoire.',
    referenceExterneEmpty: 'La reference externe est obligatoire',
  },
};

export default SIGNATURE_ELECTRONIQUE;
